﻿

(() => {
    angular.module('fliptoWeb')


        .animation('.carousel-nav-animate', [function () {
        return {
            beforeAddClass: function (element, className, done) {
                var link = element.children('a')[0];

                var tl = new TimelineLite({ onComplete: done });
                tl.to(link, .2, { height: "+=20px", width: "+=20px", margin: '-=10px', ease: Power2.easeOut });

                return function (cancelled) {
                    //this (optional) function will be called when the animation
                    //completes or when the animation is cancelled (the cancelled
                    //flag will be set to true if cancelled).
                }
            },

            beforeRemoveClass: function (element, className, done) {
                var link = element.children('a')[0];

                var tl = new TimelineLite({ onComplete: done });
                tl.to(link, .2, { height: "-=20px", width: "-=20px", margin: '+=10px', ease: Power2.easeOut });

                return function (cancelled) {
                    //this (optional) function will be called when the animation
                    //completes or when the animation is cancelled (the cancelled
                    //flag will be set to true if cancelled).
                }
            }
        }
    }])



    .animation('.carousel-slide-animate', [function () {
        return {
            beforeAddClass: function (element, className, done) {
                var tl = new TimelineLite({ onComplete: done });
                tl.to(element, .3, { opacity: 0 });

                return function (cancelled) {
                    //this (optional) function will be called when the animation
                    //completes or when the animation is cancelled (the cancelled
                    //flag will be set to true if cancelled).
                }
            },

            beforeRemoveClass: function (element, className, done) {
                var tl = new TimelineLite({ onComplete: done });
                tl.to(element, .3, { opacity: 1 });

                return function (cancelled) {
                    //this (optional) function will be called when the animation
                    //completes or when the animation is cancelled (the cancelled
                    //flag will be set to true if cancelled).
                }
            }
        }
    }]);
})()
